import { z } from 'zod'

export const ZipCodeSchema = z
  .string()
  .trim()
  .regex(/^\d{5}$/, { message: 'Invalid zip code.' })
  .describe('Zip code')
